import Keycloak from 'keycloak-js';

export { useKeycloak } from '@react-keycloak/web';

export default new Keycloak('/tcml/kc-config');

/** ***************************************************** */
/* some helper functions to store and retrieve the tokens */
/** ***************************************************** */

export type StoredToken = {
  idToken?: string;
  token?: string;
  refreshToken?: string;
};

export function storeToken(tokens: StoredToken): void {
  localStorage.setItem('tokendata', JSON.stringify(tokens));
}

export function getToken(): StoredToken {
  const obj = localStorage.getItem('tokendata');
  if (obj) {
    return JSON.parse(obj) as StoredToken;
  }
  return {} as StoredToken;
}
